"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var isNull_1 = __importDefault(require("lodash/isNull"));
var TextInput = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-UserProfileModal_InputWrapper" },
        react_1.default.createElement("label", { htmlFor: label, className: "usersEstimatesRequestsMessages-UserProfileModal_InputLabel" }, label),
        react_1.default.createElement("input", { type: "text", id: label, value: (0, isNull_1.default)(value) ? undefined : value, onChange: function (e) { return onChange(e.target.value); }, className: "usersEstimatesRequestsMessages-UserProfileModal_Input" })));
};
exports.default = TextInput;
